// extracted by css-extract-rspack-plugin
export default {"accordion":"SPAjh2qyCysmbnqa","details":"VbOymPD1YOKWpxaU"};